import {
  FETCH_UPDATE_PROJECT_REQUEST,
  FETCH_UPDATE_PROJECT_SUCCESS,
  FETCH_UPDATE_PROJECT_FALUIRE,
} from './updateProjectByProjectIDTypes'

const initialState = {
  loading: false,
  updateProjectInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UPDATE_PROJECT_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_PROJECT_SUCCESS : return {
      ...state,
      updateProjectInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_PROJECT_FALUIRE : return {
      ...state,
      loading: false,
      updateProjectInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
